export default __webpack_public_path__ + "static/media/questionmark-icon.84e028ee.svg";